import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { Popup } from "@/Common/Components/Modals/Popup";
import { CheckboxUIModelT } from "@/Common/Models/UI/Inputs/CheckboxUIModel";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { MedicationModel } from "@/Patient/Models/Medication/MedicationModel";
import { PatientPrescriptionTabHandler } from "@/Patient/Stores/Handlers/Local/Medication/PatientPrescriptionTabHandler";

interface IPatientPrescriptionActiveMedicationConflicPopupProps {
    PatientContactId: string;
    MedicationsToPrescribe: Immutable.List<MedicationModel>;
    onCloseOperation: number;
}

class PatientPrescriptionActiveMedicationConflicPopupState {
    public ActiveMedicationsInConflic: Immutable.List<CheckboxUIModelT<MedicationModel>>;
}

class PatientPrescriptionActiveMedicationConflicPopup extends React.Component<IPatientPrescriptionActiveMedicationConflicPopupProps, PatientPrescriptionActiveMedicationConflicPopupState> {
    public constructor(props: IPatientPrescriptionActiveMedicationConflicPopupProps) {
        super(props);

        const relatedActivemedIdsInConflic: string[] = [];

        props.MedicationsToPrescribe.forEach(med => {
            med.GetConflictingActiveMedFollowingDSQRenew().forEach(id => {
                relatedActivemedIdsInConflic.push(id);
            });
        });

        const uniqueIds = relatedActivemedIdsInConflic.distinct();

        const activeMeds = uniqueIds.map(id => {
            const resolvedMed = PatientPrescriptionTabHandler.GetMedicationById(id, props.PatientContactId);
            return new CheckboxUIModelT<MedicationModel>({
                Id: resolvedMed.Model.Id,
                Name: resolvedMed.GetName(false),
                Model: resolvedMed,
                Checked: true
            });
        });
        const initialState = new PatientPrescriptionActiveMedicationConflicPopupState();
        initialState.ActiveMedicationsInConflic = activeMeds.toImmutable();

        this.state = initialState;
    }

    public render(): JSX.Element {
        let self = this;

        return (
            <Popup cssClass="double-booking" title="Mise à jour des médicaments déjà au dossier" closeTarget={this.props.onCloseOperation}>
                <div className="p-body" style={{ "overflowY": "auto", "paddingBottom": "50px" }}>
                    <div style={{ marginBottom: "5px" }}>{"Les renouvellements DSQ remplaceront les médicaments suivants dans le dossier : "}</div>
                    {this.state.ActiveMedicationsInConflic.map((ckbItem, idx) => {
                        let dosageDisplay = ckbItem.Model.GetDosageString({ includeDaysOrQty: false });
                        if (IsNullOrWhiteSpace(dosageDisplay))
                            dosageDisplay = ckbItem.Model.GetInstruction();

                        return (
                            <div key={"patPrescriptionConflicPopup_item_" + idx} style={{ marginBottom: "15px" }}>
                                <CheckboxControl
                                    id={"patPrescriptionConflicPopup_" + ckbItem.Id}
                                    label={ckbItem.Name}
                                    checked={ckbItem.Checked}
                                    onChange={() => self.mutateStateChecbox(ckbItem.Id, ckb => ckb.Checked = !ckb.Checked)}
                                />
                                <div style={{ marginLeft: "10px", marginTop: "-10px", overflow: "hidden", textOverflow: "ellipsis", width: "220px", whiteSpace: "nowrap" }}>{dosageDisplay}</div>
                            </div>
                        );
                    })}
                </div>

                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <ButtonControl
                                    className="btn btn-default push-right-5"
                                    onClick={() => sessionStore.dispatch(this.props.onCloseOperation)}
                                    label={cacheStore.GetString("CancelLabel")}
                                />
                                <ButtonControl
                                    className="btn btn-primary"
                                    onClick={() => self.onAccept()}
                                    label={cacheStore.GetString("PrescribeLabel")}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }

    private mutateState(mutation: (s: PatientPrescriptionActiveMedicationConflicPopupState) => void, then: any = null): void {
        var s = new PatientPrescriptionActiveMedicationConflicPopupState();
        mutation(s);
        this.setState(s, then);
    }

    private mutateStateChecbox(Id: string, mutation: (ckb: CheckboxUIModelT<MedicationModel>) => void): void {
        let self = this;
        this.mutateState(s => {
            s.ActiveMedicationsInConflic = self.state.ActiveMedicationsInConflic.toArray()
                .map(x => {
                    if (x.Id == Id)
                        mutation(x);

                    return x;
                })
                .toImmutable();
        });
    }

    public onAccept(): void {
        let MedicationValidated = this.props.MedicationsToPrescribe.map(x => x.Model.Id);
        let MedicationToMarkAsCompleted = this.state.ActiveMedicationsInConflic.filter(x => x.Checked == true).map(x => x.Model.Model.Id);

        sessionStore.dispatch(LocalPatientOperations.PrescriptionTab.Prescribe, {
            lastAcceptedMyleActiveMedicationConflic: MedicationValidated,
            medicationToMarkAsCompleted: MedicationToMarkAsCompleted,
            withSignature: false
        });
    }
}

export { PatientPrescriptionActiveMedicationConflicPopup };
